import { useState } from 'react'

import { getAPIClient } from 'api/axios'

interface RemoveBillingCouponResponse {
  message: string
  quota_returned: boolean
  billing: { uuid: string; amount_billed: number }
}

interface UseRemoveBillingCouponReturn {
  removeBillingCoupon: (
    billingUuid: string
  ) => Promise<RemoveBillingCouponResponse>
  loading: boolean
  error: string | null
}

export const useRemoveBillingCoupon = (): UseRemoveBillingCouponReturn => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const client = getAPIClient()

  const removeBillingCoupon = async (
    billingUuid: string
  ): Promise<RemoveBillingCouponResponse> => {
    setLoading(true)
    setError(null)

    try {
      const response = await client.delete(`/v1/billings/${billingUuid}/coupon`)
      return response.data
    } catch (err: any) {
      const message =
        err?.response?.data?.message || 'Erro ao remover cupom da cobrança'
      setError(message)
      throw message
    } finally {
      setLoading(false)
    }
  }

  return { removeBillingCoupon, loading, error }
}
